import { Layer, Rectangle, ResponsiveContainer, Sankey } from "recharts";

import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";

const SankeySkeletonNode = (props: any) => {
  const theme = useTheme();
  const { x, y, width, height } = props;
  return (
    <Layer>
      <Rectangle
        className="infinite-pulsing"
        x={x}
        y={y || 0}
        width={width * 2}
        height={height}
        fill={theme.igPrimitives.gray["A100"]}
      />
    </Layer>
  );
};

export const IgSankeyChartSkeleton = () => {
  const theme = useTheme();
  const fakeSankeyData = {
    nodes: [
      { name: "A" },
      { name: "B" },
      { name: "C" },
      { name: "D" },
      { name: "E" },
      { name: "F" },
      { name: "G" },
      { name: "H" },
      { name: "I" },
      { name: "J" },
      { name: "K" },
      { name: "L" },
      { name: "M" },
      { name: "O" },
    ],
    links: [
      { source: 0, target: 1, value: 100 },
      { source: 0, target: 2, value: 100 },

      { source: 1, target: 3, value: 10 },
      { source: 1, target: 4, value: 25 },
      { source: 1, target: 5, value: 20 },
      { source: 1, target: 6, value: 20 },
      { source: 1, target: 7, value: 15 },
      { source: 1, target: 8, value: 10 },

      { source: 2, target: 8, value: 30 },
      { source: 2, target: 9, value: 70 },

      { source: 8, target: 10, value: 20 },
      { source: 8, target: 12, value: 20 },
      { source: 9, target: 13, value: 70 },
    ],
  };
  return (
    <Grid>
      <ResponsiveContainer width="100%" height={600}>
        <Sankey
          data={fakeSankeyData}
          node={<SankeySkeletonNode />}
          sort={false}
          nodePadding={40}
          margin={{ left: 20, right: 20, top: 20, bottom: 20 }}
          link={{ stroke: theme.igPrimitives.gray[900] }}
        />
      </ResponsiveContainer>
    </Grid>
  );
};
